const Keys = Object.freeze({
  LICENSEAPIKEY: 'licenseApiKey',
  CASTING_DEVICES: 'casting_devices',
  DEVICEREGDATA: 'deviceRegData',
  GRPWALLPAPER: 'grpWallpaper',
  SLIDERTIMER: 'sliderTimer',
  DEVICELIST: 'DeviceList',
  LANGUAGEID: 'language_id',
  CURRENTLOCATION: 'currentLocation',
  ORGANIZATIONLOCATIONS: 'organizationLocations',
  WEATHERAPI: 'weatherApi',
  WEATHERDETAIL: 'weatherDetail',
  LATESTNEWS: 'latestNews',
  WELCOMENOTE: 'welcomeNote',
  ACCREDITATIONS: 'accreditations',
  PROFILECATEGORY: 'profileCategory',
  PROFILE: 'profile',
  ORGCHANNEL: 'orgChannel',
  HASRADIOCHANNEL: 'hasRadioChannel',
  ORGGRPCHANNEL: 'orgGrpChannel',
  ORGTEMPLATE: 'orgTemplate',
  ORGGRPTEMPLATE: 'orgGrpTemplate',
  ACTIVETEMPLATE: 'activeTemplate',
  ORGTHEME: 'orgTheme',
  ORGGRPTHEME: 'orgGrpTheme',
  ACTIVETHEME: 'activeTheme',
  LANGUAGE: 'language',
  LANGUAGECODE: 'language_code',
  BUTTONS: 'buttons',
  CUSTOMERDATA: 'customerData',
  ROOMDATA: 'roomData',
  FOCUSINDEX: 'focusIndex',
  PROXYURL: 'proxyUrl',
  ITERATION: 'iteration',
  IGNORE_PROXY: 'ignorep_proxy',
  CHANNELONLY: 'channel_only',
  ORGANIZATIONGROUP: 'organization_group',
  SELECTEDORGANIZATIONGROUP: 'selected_organization_group',
  ORGANIZATION_IDENTITY: 'organizationIdentity',
  THIRD_PARTY_CACHE: 'third_party_cache',
  PATIENT_PROFILE_SEGMENTS: 'patientProfileSegments',
  PATIENT_PROFILE_FIELDS: 'patientProfileFields',
  PATIENT_PROFILE_SUBFIELDS: 'patientProfileSubFields',
  PATIENT_HL7_DATA: 'patientHl7Data',
  EXPERIENCE_SELECTION: 'experienceSelection',
});

const obj = { Keys };

export default obj;
